
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"72","height":"86","viewBox":"0 0 72 86","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.633 26.735c1.904-13.288-9.11-20.882-9.11-20.882","stroke":"#000","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M37.63 26.123s11.284-7.17 24.827.876C76 35.046 68.364 60.767 68.364 60.767S59.858 83.86 50.824 83.86c-4.752.858-11.114-2.095-11.114-2.095s-4.518-2.628-8.506-.172c-3.998 2.448-9.895 5.076-15.102 0-4.84-4.732-18.84-20.636-13.104-43.241 1.488-5.862 5.458-10.874 10.988-13.24 3.048-1.3 6.875-2.023 11.518-1.282 1.344.216 2.653.632 3.898 1.183 1.981.885 5.737 2.24 8.228 1.11z","fill":"#F44747","stroke":"#000","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M40.2 56.683s-.89 3.659-4.804 3.659-4.804-3.66-4.804-3.66","stroke":"#010101","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M44.85 49.772s.632-2.598 3.414-2.598c2.783 0 3.415 2.598 3.415 2.598M19.857 49.772s.632-2.598 3.415-2.598 3.415 2.598 3.415 2.598","stroke":"#000","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M35.852 21.934S35.703 6.692 49.96 1.855c0 0 4.44 15.846-11.822 22.594l-2.286.955v-3.468z","fill":"#16D2AA","stroke":"#000","stroke-width":"2","stroke-miterlimit":"10"}})])
          )
        }
      }
    